import apiClient from "../../../../utilities/apiClient";

export const panVerify = (payload) => {
  return apiClient.post(`${apiClient.Urls.panVerification}`, payload);
};
